<template>
  <div
    style="
      height: 100vh;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <div
      style="
        max-width: 600px;
        width: 100%;
        padding: 40px;
        background: #fff;
        border-radius: 10px;
      "
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 30px;
        "
      >
        <img
          style="width: 240px; height: 240px"
          src="https://cdn.zhaosheng.daheyun1314.com/ca6c04612b054bfb989ce6c5fbedb1e2.png"
          alt="系统维护"
        />
      </div>

      <div
        style="
          color: #101010;
          font-size: 16px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 20px;
        "
      >
        系统升级维护中{{ dots }}
      </div>

      <div
        v-if="maintenanceInfo.title"
        style="
          color: #333;
          font-size: 14px;
          line-height: 28px;
          margin-bottom: 20px;
          font-weight: 500;
          text-indent: 2em;
        "
      >
        <span v-html="highlightDate(maintenanceInfo.title)"></span>
      </div>

      <div
        v-else
        style="
          color: #333;
          font-size: 14px;
          line-height: 24px;
          margin-bottom: 20px;
          text-indent: 2em;
        "
      >
        为了给您提供更优质的服务，系统正在进行升级维护，维护期间暂停相关服务，给您带来的不便敬请谅解!
      </div>

      <div
        v-if="errorMsg"
        style="
          color: #ff0000;
          background: #fff5f5;
          font-size: 14px;
          line-height: 24px;
          text-align: center;
          margin-bottom: 10px;
          padding: 10px 0;
        "
      >
        {{ errorMsg }}
      </div>
    </div>
  </div>
</template>

<script>
import { checkMaintenance, clearMaintenance } from "@/utils/maintenance";

export default {
  name: "MaintenancePage",
  data() {
    return {
      maintenanceInfo: {},
      errorMsg: "",
      dots: "...",
      dotTimer: null,
      fetchTimer: null,
    };
  },

  created() {
    // 接收 URL 传递的错误信息
    const errorMsg = this.$route.query?.errorMsg;
    if (errorMsg) {
      this.errorMsg = decodeURIComponent(errorMsg);
      console.log("接收到错误信息:", this.errorMsg);
    }
  },

  mounted() {
    console.log("[Maintenance] 查询运维配置");
    this.fetchMaintenanceStatus();
    this.startDotAnimation();
    // 每 3 分钟刷新一次运维配置
    this.fetchTimer = setInterval(() => {
      this.fetchMaintenanceStatus();
    }, 3 * 60 * 1000);
  },

  beforeDestroy() {
    this.clearTimers();
  },

  methods: {
    // 启动省略号动画
    startDotAnimation() {
      const arr = [".", "..", "..."];
      let i = 0;
      this.dots = arr[i];
      this.dotTimer = setInterval(() => {
        i = (i + 1) % arr.length;
        this.dots = arr[i];
      }, 500);
    },

    // 获取运维配置
    fetchMaintenanceStatus() {
      checkMaintenance({
        onMaintenance: (data) => {
          // 已进入维护模式，展示远程维护信息
          if (data) {
            this.maintenanceInfo.title = data.title || "";
            if (data.message || data.msg) {
              this.errorMsg = data.message || data.msg;
            }
          }
        },
        onNormal: (data) => {
          // 维护已结束，checkMaintenance 内部已跳转首页
          if (data) {
            this.maintenanceInfo.title = data.title || "";
            if (data.message || data.msg) {
              this.errorMsg = data.message || data.msg;
            }
          }
          clearMaintenance();
        },
      });
    },

    // 清除定时器
    clearTimers() {
      if (this.dotTimer) {
        clearInterval(this.dotTimer);
        this.dotTimer = null;
      }
      if (this.fetchTimer) {
        clearInterval(this.fetchTimer);
        this.fetchTimer = null;
      }
    },

    // 高亮日期部分为红色
    highlightDate(date) {
      if (!date) return date;
      const datePattern =
        /(\d{4}年\d{1,2}月(?:\d{1,2})?日?\s*\d{1,2}:\d{2}起?)|(\d{4}年\d{1,2}月(?:\d{1,2})?日?\d{1,2}:\d{2}起?)|(\d{4}年\d{1,2}月(?:\d{1,2})?日?\s*\d{1,2}:\d{2}起?)|(\d{4}年\d{1,2}月(?:\d{1,2})?日)/g;

      return date.replace(
        datePattern,
        '<span style="color: #ff0000;">$&</span>',
      );
    },
  },
};
</script>
